// @flow

import * as React from "react";
import {
    useLocation,
    withRouter,
    Switch,
    Redirect,
    useHistory,
    Route,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NProgress from "nprogress";
import API from "../api/user";
import Config from "../constants/Config";
import actions from "../actions/index.js";
import useAsyncState from "../hooks/useAsyncState";
import Loader from "../components/atoms/Loader";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import CustomMeta from "../components/atoms/CustomMeta.js";
import NavManageClubs from "../components/organisms/NavManageClubs";
import ManageClubsEventsBody from "../components/organisms/ManageClubsEventsBody";
import ManageClubsGrantsBody from "../components/organisms/ManageClubsGrantsBody";
import ManageClubsSponsorshipsBody from "../components/organisms/ManageClubsSponsorshipsBody";
import ManageClubsGovernanceBody from "../components/organisms/ManageClubsGovernanceBody";
import ManageClubsFooter from "../components/organisms/ManageClubsFooter";
import ManageClubsMembersBody from "../components/organisms/ManageClubsMembersBody";

type PropsType = {
    match: any,
};

const ManageClubs = (props: PropsType): React.Node => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [state, localActions] = useAsyncState();
    // const [loaded, setLoaded] = React.useState(false);
    const [activeClub, setActiveClub] = React.useState(null);
    const [managedClubs, setManagedClubs] = React.useState([]);
    const { profile } = useSelector((state: any): any => state.user);
    const isClubExec = profile.role
        ? profile.role.filter(role => role === "club_exec").length > 0
        : false;
    const selectedClub = managedClubs.filter(
        club => club.ID === parseInt(activeClub)
    )[0];

    const breadcrumbs = [
        {
            title: "My account",
            onClick: () => dispatch(actions.openAccountModal()),
            type: "button",
        },
    ];

    // initial mount use effect
    React.useEffect((): any => {
        if (!isClubExec) {
            <Redirect to={Config.routes.login} />;
        }

        NProgress.start();
        localActions.request();

        API.userGetMyClubs()
            .then((data: any) => {
                setManagedClubs(data);

                // redirect to first club in list if none set in url
                if (!props.match.params.id) {
                    if (data[0] && data[0].ID) {
                        setActiveClub(data[0].ID);
                    } else {
                        console.error("Could not find any club.");
                    }
                } else {
                    setActiveClub(props.match.params.id);
                }

                localActions.success();
            })
            .catch(error => {
                localActions.fail(error.message);
            })
            .finally(() => {
                NProgress.done();
            });
    }, []); // eslint-disable-line

    // active club use effect
    React.useEffect(() => {
        const mode = props.match.params.mode
            ? props.match.params.mode
            : "events";
        const event_id = props.match.params.event_id
            ? "/" + props.match.params.event_id
            : "";
        if (activeClub) {
            history.push(
                `${Config.routes.manageClubs}/${activeClub}/${mode}${event_id}`
            );

            // set club id currently being managed
            window.club_exec_club_id = activeClub;
        }
    }, [activeClub]); // eslint-disable-line

    return (
        <React.Fragment>
            <CustomMeta title="Manage your club" />

            <HeroProfilePage
                heading="Manage your club"
                breadcrumbs={breadcrumbs}
                customClass="manage-clubs"
            />

            <div className="manage-clubs__container">
                <div className="manage-clubs__content">
                    <div className="">
                        <div className="">
                            <div className="">
                                <Loader active={state.loading}>
                                    <div className="">
                                        <div className="">
                                            <NavManageClubs
                                                clubs={managedClubs}
                                                activeClub={activeClub}
                                                setActiveClub={setActiveClub}
                                            />
                                        </div>
                                    </div>

                                    <div className="">
                                        <div className="">
                                            <Switch location={location}>
                                                <Route
                                                    path={`${Config.routes.manageClubs}/${activeClub}/events`}
                                                    render={() => {
                                                        return (
                                                            <ManageClubsEventsBody
                                                                id={
                                                                    props.match
                                                                        .params
                                                                        .id
                                                                }
                                                            />
                                                        );
                                                    }}
                                                />
                                                <Route
                                                    path={`${Config.routes.manageClubs}/${activeClub}/members`}
                                                    render={() => {
                                                        return (
                                                            <ManageClubsMembersBody
                                                                id={
                                                                    props.match
                                                                        .params
                                                                        .id
                                                                }
                                                                club={
                                                                    selectedClub
                                                                }
                                                            />
                                                        );
                                                    }}
                                                />
                                                <Route
                                                    path={`${Config.routes.manageClubs}/${activeClub}/grants`}
                                                    render={() => {
                                                        return (
                                                            <ManageClubsGrantsBody
                                                                id={
                                                                    props.match
                                                                        .params
                                                                        .id
                                                                }
                                                                club={
                                                                    selectedClub
                                                                }
                                                            />
                                                        );
                                                    }}
                                                />
                                                <Route
                                                    path={`${Config.routes.manageClubs}/${activeClub}/sponsorships`}
                                                    render={() => {
                                                        return (
                                                            <ManageClubsSponsorshipsBody
                                                                id={
                                                                    props.match
                                                                        .params
                                                                        .id
                                                                }
                                                                club={
                                                                    selectedClub
                                                                }
                                                            />
                                                        );
                                                    }}
                                                />
                                                <Route
                                                    path={`${Config.routes.manageClubs}/${activeClub}/governance`}
                                                    render={() => {
                                                        return (
                                                            <ManageClubsGovernanceBody
                                                                id={
                                                                    props.match
                                                                        .params
                                                                        .id
                                                                }
                                                                club={
                                                                    selectedClub
                                                                }
                                                            />
                                                        );
                                                    }}
                                                />
                                            </Switch>
                                        </div>
                                    </div>
                                </Loader>
                            </div>
                        </div>

                        <ManageClubsFooter />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

ManageClubs.preload = ({ location, passed: { store } }: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(ManageClubs);
